(function () {
  'use strict';

  var state = {
    items: [],   // [{src, caption, products}]
    index: 0,
    fromRect: null
  };
  var overlay = null;

  function parseProducts(raw) {
    if (!raw) return [];
    try { return JSON.parse(raw); } catch (e) { return []; }
  }

  function build(buttons) {
    return buttons.map(function (btn) {
      return {
        src:      btn.getAttribute('data-full-src') || (btn.querySelector('img') || {}).src,
        caption:  btn.getAttribute('data-caption') || '',
        products: parseProducts(btn.getAttribute('data-products') || ''),
        hotspots: parseProducts(btn.getAttribute('data-hotspots') || ''),
        thumb:    btn.querySelector('img')
      };
    });
  }

  function ensureOverlay() {
    if (overlay) return overlay;
    overlay = document.createElement('div');
    overlay.className = 'tp-photo-lightbox';
    overlay.setAttribute('role', 'dialog');
    overlay.setAttribute('aria-modal', 'true');
    overlay.setAttribute('aria-hidden', 'true');
    overlay.innerHTML =
      '<button type="button" class="tp-photo-lightbox__close" aria-label="閉じる">×</button>' +
      '<button type="button" class="tp-photo-lightbox__nav tp-photo-lightbox__nav--prev" aria-label="前の写真">‹</button>' +
      '<button type="button" class="tp-photo-lightbox__nav tp-photo-lightbox__nav--next" aria-label="次の写真">›</button>' +
      '<div class="tp-photo-lightbox__stage">' +
        '<div class="tp-photo-lightbox__track">' +
          '<div class="tp-photo-lightbox__slide" data-slide="prev">' +
            '<div class="tp-photo-lightbox__media"><img alt=""><div class="tp-photo-lightbox__hotspots"></div></div>' +
          '</div>' +
          '<div class="tp-photo-lightbox__slide" data-slide="current">' +
            '<div class="tp-photo-lightbox__media"><img alt=""><div class="tp-photo-lightbox__hotspots"></div></div>' +
          '</div>' +
          '<div class="tp-photo-lightbox__slide" data-slide="next">' +
            '<div class="tp-photo-lightbox__media"><img alt=""><div class="tp-photo-lightbox__hotspots"></div></div>' +
          '</div>' +
        '</div>' +
      '</div>' +
      '<div class="tp-photo-lightbox__bottom">' +
        '<div class="tp-photo-lightbox__caption"></div>' +
        '<div class="tp-photo-lightbox__products"></div>' +
        '<div class="tp-photo-lightbox__counter"></div>' +
      '</div>';
    document.body.appendChild(overlay);

    overlay.querySelector('.tp-photo-lightbox__close').addEventListener('click', close);
    overlay.querySelector('.tp-photo-lightbox__nav--prev').addEventListener('click', function (e) {
      e.stopPropagation(); go(-1);
    });
    overlay.querySelector('.tp-photo-lightbox__nav--next').addEventListener('click', function (e) {
      e.stopPropagation(); go(1);
    });
    overlay.querySelector('.tp-photo-lightbox__stage').addEventListener('click', function (e) {
      if (e.target.classList.contains('tp-photo-lightbox__stage') ||
          e.target.classList.contains('tp-photo-lightbox__slide')) {
        close();
      }
    });

    document.addEventListener('keydown', function (e) {
      if (!overlay.classList.contains('is-open')) return;
      if (e.key === 'Escape') close();
      else if (e.key === 'ArrowLeft') go(-1);
      else if (e.key === 'ArrowRight') go(1);
    });

    // Swipe gestures
    var startX = 0, startY = 0, dx = 0, dy = 0, dragging = false;
    var track = overlay.querySelector('.tp-photo-lightbox__track');
    function onStart(e) {
      var t = e.touches ? e.touches[0] : e;
      startX = t.clientX; startY = t.clientY; dx = 0; dy = 0;
      dragging = true;
      track.style.transition = 'none';
    }
    function onMove(e) {
      if (!dragging) return;
      var t = e.touches ? e.touches[0] : e;
      dx = t.clientX - startX;
      dy = t.clientY - startY;
      if (Math.abs(dx) > Math.abs(dy)) {
        if (e.cancelable) e.preventDefault();
        track.style.transform = 'translateX(calc(-33.3333% + ' + dx + 'px))';
      }
    }
    function onEnd() {
      if (!dragging) return;
      dragging = false;
      track.style.transition = '';
      track.style.transform = '';
      var threshold = 50;
      if (Math.abs(dx) > threshold && Math.abs(dx) > Math.abs(dy)) {
        go(dx < 0 ? 1 : -1);
      }
    }
    overlay.addEventListener('touchstart', onStart, { passive: true });
    overlay.addEventListener('touchmove',  onMove,  { passive: false });
    overlay.addEventListener('touchend',   onEnd);
    overlay.addEventListener('touchcancel', onEnd);

    return overlay;
  }

  function renderProducts(products) {
    var box = overlay.querySelector('.tp-photo-lightbox__products');
    if (!products || !products.length) { box.innerHTML = ''; box.style.display = 'none'; return; }
    box.style.display = '';
    var html = products.map(function (p) {
      var img = p.image ? '<img src="' + p.image + '" alt="" loading="lazy">' : '';
      return (
        '<a class="tp-photo-lightbox__product" href="' + p.url + '">' +
          img +
          '<span class="tp-photo-lightbox__product-info">' +
            '<span class="tp-photo-lightbox__product-title">' + p.title + '</span>' +
            (p.price ? '<span class="tp-photo-lightbox__product-price">' + p.price + '</span>' : '') +
          '</span>' +
        '</a>'
      );
    }).join('');
    box.innerHTML = html;
  }

  function renderHotspotsFor(slideEl, hotspots) {
    var holder = slideEl.querySelector('.tp-photo-lightbox__hotspots');
    if (!holder) return;
    if (!hotspots || !hotspots.length) { holder.innerHTML = ''; return; }
    holder.innerHTML = hotspots.map(function (h, i) {
      var img = h.image ? '<img src="' + h.image + '" alt="" loading="lazy">' : '';
      var posClasses = '';
      if (h.y < 28) posClasses += ' is-top';
      if (h.x < 22) posClasses += ' is-left';
      else if (h.x > 78) posClasses += ' is-right';
      return (
        '<div class="tp-photo-lightbox__hotspot' + posClasses + '" style="--x: ' + h.x + '%; --y: ' + h.y + '%;" data-hotspot-i="' + i + '">' +
          '<button type="button" class="tp-photo-lightbox__dot" aria-label="' +
            (h.title || '').replace(/"/g, '&quot;') + '">' +
            '<span class="tp-photo-lightbox__dot-pulse"></span>' +
          '</button>' +
          '<a class="tp-photo-lightbox__hotspot-card" href="' + h.url + '">' +
            img +
            '<span class="tp-photo-lightbox__hotspot-info">' +
              '<span class="tp-photo-lightbox__hotspot-title">' + (h.title || '') + '</span>' +
              (h.price ? '<span class="tp-photo-lightbox__hotspot-price">' + h.price + '</span>' : '') +
            '</span>' +
          '</a>' +
        '</div>'
      );
    }).join('');
    // Wire up dot toggles
    holder.querySelectorAll('.tp-photo-lightbox__dot').forEach(function (b) {
      b.addEventListener('click', function (e) {
        e.stopPropagation();
        var parent = b.closest('.tp-photo-lightbox__hotspot');
        // Close other open hotspots in this slide
        holder.querySelectorAll('.tp-photo-lightbox__hotspot.is-open').forEach(function (o) {
          if (o !== parent) o.classList.remove('is-open');
        });
        parent.classList.toggle('is-open');
      });
    });
  }

  function positionHotspotsArea(slideEl) {
    // Make .tp-photo-lightbox__media size match the actual displayed image,
    // so hotspot %-positions map to the image (not the slide letterbox area).
    var img = slideEl.querySelector('img');
    var media = slideEl.querySelector('.tp-photo-lightbox__media');
    if (!img || !media || !img.naturalWidth) return;
    var slideRect = slideEl.getBoundingClientRect();
    // Available area inside slide (minus padding) = the bounding box of <img>.
    // Compute the image's contained size within the slide.
    var availW = slideRect.width - parseFloat(getComputedStyle(slideEl).paddingLeft || 0) - parseFloat(getComputedStyle(slideEl).paddingRight || 0);
    var availH = slideRect.height - parseFloat(getComputedStyle(slideEl).paddingTop || 0) - parseFloat(getComputedStyle(slideEl).paddingBottom || 0);
    var ar = img.naturalWidth / img.naturalHeight;
    var w, h;
    if (availW / availH > ar) {
      h = availH; w = h * ar;
    } else {
      w = availW; h = w / ar;
    }
    media.style.width = w + 'px';
    media.style.height = h + 'px';
  }

  function render() {
    var n = state.items.length;
    if (!n) return;
    var slideEls = overlay.querySelectorAll('.tp-photo-lightbox__slide');
    var iPrev = (state.index - 1 + n) % n;
    var iNext = (state.index + 1) % n;
    var order = [iPrev, state.index, iNext];
    order.forEach(function (idx, slot) {
      var newSrc = state.items[idx].src;
      var slideEl = slideEls[slot];
      var mediaEl = slideEl.querySelector('.tp-photo-lightbox__media');
      var oldImg = mediaEl.querySelector('img');
      // Skip if already showing the correct image
      if (oldImg && oldImg.getAttribute('src') === newSrc) {
        return;
      }
      // Replace the <img> with a fresh one — this guarantees no residual
      // (previously-decoded) image is shown during the new image's load.
      var newImg = document.createElement('img');
      newImg.alt = '';
      newImg.style.display = 'block';
      newImg.style.width = '100%';
      newImg.style.height = '100%';
      newImg.style.objectFit = 'contain';
      newImg.style.opacity = '0';
      newImg.src = newSrc;
      if (oldImg) {
        mediaEl.replaceChild(newImg, oldImg);
      } else {
        mediaEl.insertBefore(newImg, mediaEl.firstChild);
      }
      var setupAfterLoad = function () {
        // Keep current slide invisible only during the INITIAL open (so the
        // FLIP/entrance can reveal it). When already open (e.g. swiping),
        // show immediately so swipe navigation isn't broken.
        var keepHidden = slot === 1 && !overlay.classList.contains('is-open');
        if (!keepHidden) {
          newImg.style.opacity = '';
        }
        positionHotspotsArea(slideEl);
        renderHotspotsFor(slideEl, state.items[idx].hotspots);
      };
      // Use decode() so we wait until the bitmap is ready to be painted.
      if (newImg.decode) {
        newImg.decode().then(setupAfterLoad).catch(setupAfterLoad);
      } else if (newImg.complete && newImg.naturalWidth) {
        setupAfterLoad();
      } else {
        newImg.addEventListener('load', setupAfterLoad, { once: true });
        newImg.addEventListener('error', setupAfterLoad, { once: true });
      }
    });
    var cap = overlay.querySelector('.tp-photo-lightbox__caption');
    cap.textContent = state.items[state.index].caption || '';
    cap.style.display = state.items[state.index].caption ? 'block' : 'none';
    overlay.querySelector('.tp-photo-lightbox__counter').textContent =
      (state.index + 1) + ' / ' + n;
    renderProducts(state.items[state.index].products);
  }

  // Reposition hotspot area on resize
  window.addEventListener('resize', function () {
    if (!overlay || !overlay.classList.contains('is-open')) return;
    overlay.querySelectorAll('.tp-photo-lightbox__slide').forEach(positionHotspotsArea);
  });

  function go(delta) {
    var n = state.items.length;
    if (n <= 1) return;
    state.index = (state.index + delta + n) % n;
    render();
  }

  function playFlipOpen(rect) {
    // FLIP: animate the current image from the thumbnail's rect to identity.
    // Image is expected to be opacity:0 entering this function; we set the
    // initial transform AND make it visible in a single reflow so there's
    // no "double jump" (no center-flash before the FLIP).
    var currentSlide = overlay.querySelector('.tp-photo-lightbox__slide[data-slide="current"] img');
    if (!currentSlide || !rect) {
      if (currentSlide) currentSlide.style.opacity = '';
      return;
    }
    var afterRect = currentSlide.getBoundingClientRect();
    if (!afterRect.width || !afterRect.height) {
      currentSlide.style.opacity = '';
      return;
    }
    var dx = (rect.left + rect.width / 2) - (afterRect.left + afterRect.width / 2);
    var dy = (rect.top + rect.height / 2) - (afterRect.top + afterRect.height / 2);
    var sx = rect.width / afterRect.width;
    var sy = rect.height / afterRect.height;
    var scale = Math.min(sx, sy);
    // Position at thumbnail rect, still invisible
    currentSlide.style.transformOrigin = 'center center';
    currentSlide.style.transition = 'none';
    currentSlide.style.transform = 'translate(' + dx + 'px,' + dy + 'px) scale(' + scale + ')';
    // Force reflow so the initial transform is applied
    void currentSlide.offsetWidth;
    // Now enable transition, make visible at thumbnail position, animate to identity
    currentSlide.style.transition = 'transform 0.55s cubic-bezier(0.22, 1, 0.36, 1), opacity 0.35s ease';
    currentSlide.style.opacity = '';
    currentSlide.style.transform = '';
    setTimeout(function () {
      if (currentSlide) {
        currentSlide.style.transition = '';
        currentSlide.style.transformOrigin = '';
      }
    }, 700);
  }

  function open(items, idx, fromRect) {
    state.items = items;
    state.index = idx || 0;
    state.fromRect = fromRect || null;
    ensureOverlay();
    render();
    // Wait for the current slide's image to be fully decoded before showing
    // the overlay & running FLIP. This guarantees no residual image flashes.
    var curImg = overlay.querySelector('.tp-photo-lightbox__slide[data-slide="current"] img');
    var runEntrance = function () {
      requestAnimationFrame(function () {
        overlay.classList.add('is-open');
        overlay.setAttribute('aria-hidden', 'false');
        document.body.classList.add('tp-photo-lightbox-open');
        // FLIP animation removed — just reveal the image directly.
        if (curImg) curImg.style.opacity = '';
      });
    };
    if (curImg && curImg.decode) {
      curImg.decode().then(runEntrance).catch(runEntrance);
      setTimeout(runEntrance, 1000); // safety
    } else if (curImg && (!curImg.complete || !curImg.naturalWidth)) {
      var onReady = function () {
        curImg.removeEventListener('load', onReady);
        curImg.removeEventListener('error', onReady);
        runEntrance();
      };
      curImg.addEventListener('load', onReady);
      curImg.addEventListener('error', onReady);
      setTimeout(runEntrance, 800);
    } else {
      runEntrance();
    }
  }

  function close() {
    if (!overlay) return;
    overlay.classList.remove('is-open');
    overlay.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('tp-photo-lightbox-open');
  }

  // Grid entrance now handled by <xo-animate xo-cascade> wrapper (matches
  // the default collection card entrance). Custom IntersectionObserver
  // entrance removed.

  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('.tp-photo-grid__item');
    if (!btn) return;
    var grid = btn.closest('[data-tp-photo-grid]');
    if (!grid) return;
    e.preventDefault();
    e.stopPropagation();
    var buttons = Array.prototype.slice.call(grid.querySelectorAll('.tp-photo-grid__item'));
    var items = build(buttons);
    // Compute index by DOM position of the actually-clicked element.
    var idx = buttons.indexOf(btn);
    if (idx < 0) idx = 0;
    var img = btn.querySelector('img');
    var clickedSrc = (img && img.src) || '';
    // Diagnostic — visible in browser DevTools console.
    try {
      console.log('[tp-lightbox v21]',
        'clicked-idx-via-indexOf:', idx,
        ' btn data-index attr:', btn.getAttribute('data-index'),
        ' clicked img src tail:', clickedSrc.split('/').pop(),
        ' items[idx].src tail:', (items[idx] && items[idx].src || '').split('/').pop(),
        ' total buttons:', buttons.length
      );
    } catch (err) {}
    // Safety net: if the items[idx] src does not match what was actually
    // clicked, scan for the matching item and use that.
    if (items[idx] && clickedSrc) {
      var clickedFile = clickedSrc.split('?')[0].split('/').pop();
      var itemFile = items[idx].src.split('?')[0].split('/').pop();
      if (clickedFile && itemFile && clickedFile !== itemFile) {
        for (var k = 0; k < items.length; k++) {
          var itFile = items[k].src.split('?')[0].split('/').pop();
          if (itFile === clickedFile) {
            console.warn('[tp-lightbox v21] mismatch — using corrected idx', k, 'was', idx);
            idx = k;
            break;
          }
        }
      }
    }
    var rect = img ? img.getBoundingClientRect() : btn.getBoundingClientRect();
    open(items, idx, rect);
  });
})();
